import t from "./index11.js";
import { resolveComponent as e, openBlock as c, createBlock as r } from "vue";
import m from "../../../../_virtual/index.js";
function p(o, a, i, s, l, _) {
  const n = e("DynamicLogo");
  return c(), r(n, {
    className: "logo-pci",
    dynamicContent: o.htmlContent,
    id: "logo-pci-"
  }, null, 8, ["dynamicContent"]);
}
const u = /* @__PURE__ */ m(t, [["render", p]]);
export {
  u as default
};
//# sourceMappingURL=index7.js.map
